import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useResendOTPApi } from '../../hooks/useResendOTPApi';

export const useResendOTP = () => {
  //   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createResendOTP } = useResendOTPApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createResendOTP(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Password successfully reset',
        'success'
      );
      //   queryClient.invalidateQueries({
      //     queryKey: ['getChoices'],
      //     exact: false,
      //   });
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
